import React from 'react'
import { UploadFile } from 'antd'
import { IMAGES_URL } from 'shared/constants/urls'

const MAX_SECONDS = 120

const toMegabytes = (bytes: number) =>
  (bytes / 1024 / 1024).toLocaleString('ru-RU', { maximumFractionDigits: 1 })

// вес берём у самих файлов на CDN — ровно столько скачает зритель
const fetchFileSize = async (path: string) => {
  try {
    const response = await fetch(`${IMAGES_URL}${path}`, { method: 'HEAD' })
    const length = Number(response.headers.get('content-length'))
    return response.ok && length > 0 ? length : null
  } catch {
    return null
  }
}

const useDuration = (file?: File) => {
  const [duration, setDuration] = React.useState<number | null>(null)

  React.useEffect(() => {
    setDuration(null)
    if (!file) return
    const url = URL.createObjectURL(file)
    const video = document.createElement('video')
    video.preload = 'metadata'
    video.onloadedmetadata = () => {
      // у части WebM браузер отдаёт Infinity — тогда длительность не проверяем
      if (Number.isFinite(video.duration)) setDuration(video.duration)
      URL.revokeObjectURL(url)
    }
    video.onerror = () => URL.revokeObjectURL(url)
    video.src = url
    return () => {
      video.onloadedmetadata = null
      URL.revokeObjectURL(url)
    }
  }, [file])

  return duration
}

interface Sizes {
  mobile: number | null
  desktop: number | null
}

const useSavedSizes = (video?: string | null, videoDesktop?: string | null) => {
  const [sizes, setSizes] = React.useState<Sizes>()

  React.useEffect(() => {
    setSizes(undefined)
    if (!video) return
    let isActual = true
    Promise.all([fetchFileSize(video), videoDesktop ? fetchFileSize(videoDesktop) : null]).then(
      ([mobile, desktop]) => isActual && setSizes({ mobile, desktop })
    )
    return () => {
      isActual = false
    }
  }, [video, videoDesktop])

  return sizes
}

const formatSize = (bytes: number | null) => (bytes ? `${toMegabytes(bytes)} МБ` : 'не удалось узнать')

interface Props {
  // ролик в форме: только что выбранный (originFileObj) или уже сохранённый у баннера
  file?: UploadFile
  video?: string | null
  videoDesktop?: string | null
}

export const VideoSizes = ({ file, video, videoDesktop }: Props) => {
  const newFile = file?.originFileObj
  const duration = useDuration(newFile)
  const sizes = useSavedSizes(file && !newFile ? video : null, videoDesktop)

  if (newFile) {
    if (duration !== null && duration > MAX_SECONDS) {
      return <div style={{ color: '#ff4d4f' }}>Ролик длиннее 2 минут — сохранить не получится. Обрежьте его.</div>
    }
    return <div>Размер версий нового видео появится после сохранения.</div>
  }
  if (!sizes) return null
  return (
    <>
      <div>Текущее видео после обработки:</div>
      <div>• ПК-версия сайта — {videoDesktop ? formatSize(sizes.desktop) : 'нет, загрузите видео заново'};</div>
      <div>• мобильный веб и приложение — {formatSize(sizes.mobile)}.</div>
    </>
  )
}
